<template>
  <div class="new-order-wrapper">
    <h3 class="section-title-centered">{{ title }}</h3>
    <form @submit.prevent="onSubmit" class="form-order">
      <div class="form-row">
        <div class="col-6">
          <div class="form-group row" v-if="!isChangeOrder">
            <label class="col-sm-5 col-form-label" v-translate>Customer name</label>
            <div class="col-sm-7">
              <v-select :class="{'no-show': !showDropdown}"
                v-model="newBill.customer"
                :filterable="false"
                :options="filteredCustomers"
                :ref="'customer'"
                :placeholder="$gettext('Type to search')"
                @search:focus="onFocus"
                @search="onSearch"
              >
                <template slot="no-options">
                  {{ noOptionText }} ..
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.label }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.label }}
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-5 col-form-label" v-translate>Table</label>
            <div class="col-sm-7">
              <input-pad
                name="table"
                :item="newBill"
                :property="'table'"
                :alphabetable="true"
                :attributes="{'class': 'form-control'}"
                :error="errors.first('table')"
                v-validate="newBill.room ? '' : 'required'"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-5 col-form-label" v-translate>Room</label>
            <div class="col-sm-7">
              <input-pad
                name="room"
                :item="newBill"
                :property="'room'"
                :alphabetable="true"
                :attributes="{'class': 'form-control'}"
                :error="errors.first('room')"
                v-validate="newBill.table ? '' : 'required'"/>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-5 col-form-label" v-translate># of Customers</label>
            <div class="col-sm-7">
              <input-pad
                name="cover"
                :item="newBill"
                :property="'cover'"
                :attributes="{'class': 'form-control'}"
                :error="errors.first('cover')"
                v-validate="'numeric'"/>
            </div>
          </div>
          <div class="form-group row" v-if="!isChangeOrder">
            <label class="col-sm-5 col-form-label" v-translate>Staff ID</label>
            <div class="col-sm-7">
              <input-pad
                name="staff"
                :item="newBill"
                :property="'staff'"
                :alphabetable="true"
                :attributes="{'class': 'form-control'}"
                :error="errors.first('staff')"
                v-validate="'required|canPostBill'"/>
            </div>
          </div>
        </div>
      </div>
      <div class="form-footer py-lg-3 text-center">
        <button id="new-order" type="submit" class="btn btn-primary px-5" v-translate>Ok</button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomerService from '@/services/CustomerService';
import BillService from '@/services/BillService';

export default {
  name: 'FormOrder',
  props: ['title', 'isChangeOrder'],
  data() {
    return {
      search: '',
      showDropdown: true,
      newBill: {room:'', table: ''}
    };
  },
  created() {
    this.newBill = Object.assign({}, this.emptyBill);
    // autoload staff here
    const staffs = this.staffs;
    if(!this.isCashier) {
      this.newBill.staff = this.user.ref;
    }
  },
  computed: {
    room() { return this.newBill.room },
    table() { return this.newBill.table },
    bill: {
      get() { return this.getMap('bill', true) },
      set(value) { this.$store.state.bill.bill = value },
    },
    emptyBill() { return this.getMap('emptyBill', true) },
    customers() { return this.getArray('customers') },
    staffs() { return this.getArray('staffs') },
    user() { return this.getMap('user', true) },
    filteredCustomers() {
      let customers = this.customers;
      if(this.search) {
        customers = this.customers.filter(customer => customer.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1);
      }
      const transformedCustomers = [];
      customers.forEach(customer => {
        transformedCustomers.push({
          label: customer.name,
          value: customer.id,
        });
      });
      return transformedCustomers;
    },
    noOptionText() {
      return this.search ? this.$gettext('No results found') : this.$gettext('Type to search');
    },
  },
  watch: {
    room(value) {
      if(value) this.newBill.table = '';
    },
    table(value) {
      if(value) this.newBill.room = '';
    }
  },
  methods: {
    async onSubmit() {
      const formValid = await this.$validator.validate();
      if (formValid) {
        if (this.isChangeOrder) {
          this.bill.cover = this.newBill.cover;
          this.bill.table = this.newBill.table;
          this.bill.room = this.newBill.room;
          await BillService.post(this.bill);
        } else {
          this.newBill.staff = this.staffs.find(staff => staff.ref == this.newBill.staff).id;
          if(this.newBill.customer) {
            this.newBill.customer = this.newBill.customer.value;
          }
          this.newBill.billItems = [];
          this.$store.dispatch('resetBill');
          this.bill = Object.assign({}, this.newBill);
        }
        this.$router.replace({ name: 'order' });
      }
    },
    onSearch(search, loading) {
      this.search = search;
    },
    onFocus() {
      this.showDropdown = this.$refs.customer.mutableOptions.length > 0;
    },
  },
};
</script>
